import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FaPlane, FaCar } from 'react-icons/fa';
import { IoHome } from 'react-icons/io5';
import { FaMapLocationDot } from 'react-icons/fa6';

const CourseDetails2 = () => {
  const { formationCode } = useParams();
  const [formation, setFormation] = useState(null);
  const [session, setSession] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null); // La session sélectionnée
  const [modeChoisi, setModeChoisi] = useState('Présentiel');
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  const Url = process.env.REACT_APP_URL_DEV;

  const handleInscription = (e) => {
    if (!selectedSession) {
      e.preventDefault();
      setErrorMessage('Veuillez choisir une session avant de continuer !');
    }
  };

  useEffect(() => {
    axios
      .get(`${Url}/api/Formation/formations/${formationCode}`)
      .then((response) => {
        if (
          Array.isArray(response.data.data) &&
          response.data.data.length > 0
        ) {
          setFormation(response.data.data[0]);
          setSession(response.data.data[0].Session);
          // Précocher la première session par défaut si elle existe
          if (response.data.data[0].Session.length > 0) {
            setSelectedSession(response.data.data[0].Session[0]);
          }
        }
      })
      .catch((error) => {
        console.error('Erreur lors de la récupération des données:', error);
      })
      .finally(() => setLoading(false));
  }, [formationCode]);

  const handleModeChange = (mode) => {
    setModeChoisi(mode);
  };

  const groupedSessions = session.reduce((acc, session) => {
    if (!acc[session.sessionVille]) acc[session.sessionVille] = [];
    acc[session.sessionVille].push(session);
    return acc;
  }, {});

  return (
    <div className="course-single-area pd-top-120 pd-bottom-90">
      <div style={{ padding: '40px' }}>
        <div className="row">
          <div className="col-lg-8 col-md-12 col-sm-12 order-2 order-lg-1">
            <div className="course-course-detaila-inner">
              <h4 style={{ color: 'black' }}>{formation?.formationNom}</h4>

              <div className="course-details-nav-tab text-center">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  {[
                    'Objectifs',
                    'Programme',
                    'Prérequis',
                    'Public',
                    'Points Forts',
                    'Certification',
                  ].map((tab, idx) => (
                    <li className="nav-item" key={idx}>
                      <a
                        className={`nav-link ${idx === 0 ? 'active' : ''}`}
                        id={`tab${idx + 1}-tab`}
                        data-toggle="tab"
                        href={`#tab${idx + 1}`}
                        role="tab"
                        aria-controls={`tab${idx + 1}`}
                        aria-selected={idx === 0 ? 'true' : 'false'}
                      >
                        {tab}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="tab1"
                  role="tabpanel"
                  aria-labelledby="tab1-tab"
                >
                  <p
                    dangerouslySetInnerHTML={{
                      __html: formation?.formationObjectif,
                    }}
                  />
                </div>
                <div
                  className="tab-pane fade"
                  id="tab2"
                  role="tabpanel"
                  aria-labelledby="tab2-tab"
                >
                  <p
                    dangerouslySetInnerHTML={{
                      __html: formation?.formationProgramme,
                    }}
                  />
                </div>
                <div
                  className="tab-pane fade"
                  id="tab3"
                  role="tabpanel"
                  aria-labelledby="tab3-tab"
                >
                  <p
                    dangerouslySetInnerHTML={{
                      __html: formation?.formationPrerequis,
                    }}
                  />
                </div>
                <div
                  className="tab-pane fade"
                  id="tab4"
                  role="tabpanel"
                  aria-labelledby="tab4-tab"
                >
                  <p
                    dangerouslySetInnerHTML={{
                      __html: formation?.formationPublic,
                    }}
                  />
                </div>
                <div
                  className="tab-pane fade"
                  id="tab5"
                  role="tabpanel"
                  aria-labelledby="tab5-tab"
                >
                  <p
                    dangerouslySetInnerHTML={{
                      __html: formation?.formationPointFort,
                    }}
                  />
                </div>
                <div
                  className="tab-pane fade"
                  id="tab6"
                  role="tabpanel"
                  aria-labelledby="tab6-tab"
                >
                  <p
                    dangerouslySetInnerHTML={{
                      __html: formation?.formationCertif,
                    }}
                  />
                </div>
              </div>
            </div>

            <h2>NOS AVANTAGES</h2>
            <div className="row mt-2">
              <div className="col-lg-3 col-sm-6 col-md-6 text-center">
                <Link to="/VisaPage">
                  <FaPlane style={{ fontSize: '50px', color: 'red' }} />
                  <p style={{ fontWeight: '600', color: 'black' }}>Visa</p>
                </Link>
              </div>
              <div className="col-lg-3 col-sm-6 col-md-6 text-center">
                <Link to="/HebegrementPage">
                  <IoHome style={{ fontSize: '50px', color: 'red' }} />
                  <p style={{ fontWeight: '600', color: 'black' }}>
                    Appui à l&apos;hébergement
                  </p>
                </Link>
              </div>
              <div className="col-lg-3 col-sm-6 col-md-6 text-center">
                <Link to="/AccueilTransfertPage">
                  <FaCar style={{ fontSize: '50px', color: 'red' }} />
                  <p style={{ fontWeight: '600', color: 'black' }}>
                    Accueil & transfert
                  </p>
                </Link>
              </div>
              <div className="col-lg-3 col-sm-6 col-md-6 text-center">
                <Link to="/VisiteTouristPage">
                  <FaMapLocationDot
                    style={{ fontSize: '50px', color: 'red' }}
                  />
                  <p style={{ fontWeight: '600', color: 'black' }}>
                    Visites touristiques
                  </p>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-12 col-sm-12 order-1 order-lg-2">
            <div className="td-sidebar">
              <div className="widget widget_feature">
                {formation?.formationType && (
                  <div className="d-flex justify-content-center mg-top-90">
                    {formation.formationType.split(',').map((type, index) => (
                      <button
                        key={index}
                        className={`custom-mode-btn mx-1 ${modeChoisi === type.trim() ? 'selected' : ''}`}
                        onClick={() => handleModeChange(type.trim())}
                        style={{ width: '130px' }}
                      >
                        {type.trim()}
                      </button>
                    ))}
                  </div>
                )}

                <ul className="mt-4">
                  <li>
                    <i className="fa fa-user " />
                    <span>Code Formation :</span> {formation?.formationCode}
                  </li>
                  <li>
                    <i className="fa fa-clock-o" />
                    <span>Durée :</span> {formation?.formationDuree}
                  </li>
                  <li>
                    <i className="fa fa-clipboard" />
                    <span>Langues :</span> {formation?.formationLangue}
                  </li>
                </ul>

                <div className="price-wrap">
                  {errorMessage && (
                    <p style={{ color: 'red', fontWeight: 'bold' }}>
                      {errorMessage}
                    </p>
                  )}

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'left',
                      gap: '2px',
                      marginBottom: '5px',
                    }}
                  >
                    <Link
                      to={{
                        pathname: '/Inscription',
                        state: {
                          formation,
                          session: selectedSession,
                          mode: modeChoisi,
                        },
                      }}
                      onClick={handleInscription}
                    >
                      <button
                        style={{
                          backgroundColor: '#FFD000',
                          color: 'white',
                          fontWeight: 'bold',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '10px 0',
                          fontSize: '16px',
                          minWidth: '200px',
                          cursor: 'pointer',
                        }}
                      >
                        {modeChoisi === 'En ligne'
                          ? 'Demande de devis'
                          : "S'inscrire"}
                      </button>
                    </Link>
                  </div>
                  {/* Bouton "Sur Mesure" supprimé */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseDetails2;
